<template>
  <div class="digit-code-input">
    <el-input
      v-for="(digit, index) in code"
      :key="index"
      :value="code[index]"
      maxlength="1"
      @input="onInput(index, $event)"
      @keydown.native.delete="onKeydown(index)"
      @paste.native="onPaste($event)"
      ref="inputs"
      class="digit-input"
    />
  </div>
</template>

<script>
export default {
  emits: ['input'],
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      code: Array(6).fill('')
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(nextValue) {
        const normalizedValue = (nextValue || '').toString().slice(0, 6)
        this.code = Array(6)
          .fill('')
          .map((digit, index) => normalizedValue[index] || digit)
      }
    }
  },
  methods: {
    onInput(index, value) {
      this.$set(this.code, index, value)

      if (value && index < this.code.length - 1) {
        this.$refs.inputs[index + 1].focus()
      }

      this.$emit('input', this.code.join(''))
    },
    onKeydown(index) {
      if (!this.code[index] && index > 0) {
        this.$refs.inputs[index - 1].focus()
      }
    },
    onPaste(event) {
      const pastedData = event.clipboardData.getData('Text')
      if (/^\d{6}$/.test(pastedData)) {
        this.code = pastedData.split('')
        this.$nextTick(() => this.$refs.inputs[5].focus())
        this.$emit('input', pastedData)
      }
      event.preventDefault()
    }
  }
}
</script>

<style scoped>
.digit-code-input {
  display: flex;
  gap: 8px;
  justify-content: center;
}

.digit-input {
  width: 40px;
  text-align: center;
}
</style>
